import { useEffect, useState } from 'react';

/**
 * Says so when the connection drops.
 *
 * This is a PWA that people open in fields, where "offline" is ordinary. Without
 * this, the first sign is a failed upload or a page stuck loading, and the
 * person has to guess the cause. It clears itself the moment the connection is
 * back.
 */
export function OfflineBanner() {
  const [online, setOnline] = useState(() =>
    typeof navigator === 'undefined' ? true : navigator.onLine,
  );

  useEffect(() => {
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener('online', up);
    window.addEventListener('offline', down);
    return () => {
      window.removeEventListener('online', up);
      window.removeEventListener('offline', down);
    };
  }, []);

  if (online) return null;

  return (
    <div className="offline-bar" role="status">
      You're offline. Reconnect to load or send anything — the app will carry on when you do.
    </div>
  );
}
